export default __webpack_public_path__ + "static/media/logo1.43c031e3.png";